import { Node } from 'slate';
import { DEFINITIONS as PLUGIN_DEFINITIONS } from '@xingternal/content-editor-plugin-emphasis';

import {
  DESERIALIZATION,
  SERIALIZATION,
  EMPHASIS_FIELDNAME,
  EMPHASIS_TYPENAME,
} from '../constants';

const DEFINITIONS = {
  ...PLUGIN_DEFINITIONS,
  __typename: EMPHASIS_TYPENAME,
};

const emphasisSerializer = ({ createBlock, matchBlock, node, direction }) => {
  if (matchBlock({ node, match: DEFINITIONS })) {
    if (direction === SERIALIZATION) {
      return { [EMPHASIS_FIELDNAME]: { text: Node.string(node) } };
    }
    if (direction === DESERIALIZATION) {
      return createBlock({
        node,
        definitions: DEFINITIONS,
        children: [{ text: node.text }],
      });
    }
  }
};

export { emphasisSerializer };
